import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LocalStorage {
  setValue(key: string, value: string): void {
    localStorage.setItem(key, value)
  }

  getValue(key: string): string {
    return localStorage.getItem(key)
  }
}
